export default {
  zh: {
    post: '发送成功',
    patch: '更新成功',
    httpDelete: '删除成功',
    loginSuccess: '登录成功',
    needUpdatePassword: '您的密码已过期，请重置您的密码。',
    needUpdatePasswordInDays: `您的密码将于{days}日内过期.`,
    logoutSuccess: '登出成功',
    invalidCode: '验证失败，请检查您的验证码并重试',
    invalidEmail: '找不到使用此电子邮件地址的帐户。',
    verificationMessage: `验证码已发送到您的注册<strong>{msg}</strong>`,
    emailAddress: '电子邮件地址',
    mobileNumber: '手机号码',
    getCode: '发送验证码',
    resendCode: '重新发送验证码',
    networkError: '网络错误，请稍后再试。'
  },
  en: {
    post: 'Successfully Sent',
    patch: 'Successfully Updated',
    httpDelete: 'Successfully Deleted',
    loginSuccess: 'Login Successfully',
    needUpdatePassword: 'Your password has expired. Please reset your password.',
    needUpdatePasswordInDays: `Your password will be expired in {days} days.`,
    logoutSuccess: 'Logout Successfully',
    invalidCode: 'Invalid code, please check and try again',
    invalidEmail: 'No account found with this email address.',
    verificationMessage: `A verification code has been sent to the <strong>{msg}</strong> registered with your account.`,
    emailAddress: 'email address',
    mobileNumber: 'mobile number',
    getCode: 'Get code',
    resendCode: 'Resend code',
    networkError: 'Network error, please try again later.'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/global/info.js